import React from 'react'
import Navbar from './Navbar'
import Herocontentl from './Herocontentl'
import HerocontentC from './HerocontentC'

function ContactHeroSec() {
  return (
    <>
    <Navbar/>
    <div className='hero-sec-container1'>
        
        <HerocontentC/>
    </div>
    </>
  )
}

export default ContactHeroSec